/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
    AdmissionStatusToJSONTyped,
} from './AdmissionStatus';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
    AdmissionStatusCodeToJSONTyped,
} from './AdmissionStatusCode';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
    LeadAdmissionStatusInfoToJSONTyped,
} from './LeadAdmissionStatusInfo';

/**
 * 
 * @export
 * @interface UpdateAdmissionStatusRequest
 */
export interface UpdateAdmissionStatusRequest {
    /**
     * Legacy display name. Use `admission_status_code`.
     * @deprecated
     */
    admission_status?: AdmissionStatus;
    /**
     * Preferred on writes; validated by per-care-setting state machine.
     */
    admission_status_code?: AdmissionStatusCode;
    /**
     * 
     */
    admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     */
    create_esign_request?: boolean;
}



/**
 * Check if a given object implements the UpdateAdmissionStatusRequest interface.
 */
export function instanceOfUpdateAdmissionStatusRequest(value: object): value is UpdateAdmissionStatusRequest {
    return true;
}

export function UpdateAdmissionStatusRequestFromJSON(json: any): UpdateAdmissionStatusRequest {
    return UpdateAdmissionStatusRequestFromJSONTyped(json, false);
}

export function UpdateAdmissionStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAdmissionStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'admission_status': json['admission_status'] == null ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'admission_status_code': json['admission_status_code'] == null ? undefined : AdmissionStatusCodeFromJSON(json['admission_status_code']),
        'admission_status_info': json['admission_status_info'] == null ? undefined : LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'create_esign_request': json['create_esign_request'] == null ? undefined : json['create_esign_request'],
    };
}

export function UpdateAdmissionStatusRequestToJSON(json: any): UpdateAdmissionStatusRequest {
    return UpdateAdmissionStatusRequestToJSONTyped(json, false);
}

export function UpdateAdmissionStatusRequestToJSONTyped(value?: UpdateAdmissionStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'admission_status': AdmissionStatusToJSON(value['admission_status']),
        'admission_status_code': AdmissionStatusCodeToJSON(value['admission_status_code']),
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value['admission_status_info']),
        'create_esign_request': value['create_esign_request'],
    };
}

